var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01054 5C9.01054 4.44772 9.45825 4 10.0105 4C10.5628 4 11.0105 4.44772 11.0105 5V10.8881L12.1048 9.7166C12.4818 9.31299 13.1146 9.29141 13.5182 9.6684C13.9218 10.0454 13.9434 10.6782 13.5664 11.0818L11.4333 13.3655C11.4183 13.3813 11.4108 13.3892 11.4032 13.397C11.3956 13.4049 11.3878 13.4126 11.3724 13.428C11.0142 13.7793 10.5574 13.9686 10.093 13.9966C10.0658 13.9989 10.0383 14 10.0105 14L10.0069 14C9.47701 14.0092 8.94451 13.8091 8.54406 13.4009L6.28617 11.0995C5.8994 10.7053 5.90544 10.0721 6.29968 9.68537C6.69391 9.29859 7.32705 9.30464 7.71383 9.69887L9.01054 11.0206V5ZM5 15C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17H15C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15H5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e9c6ad91772da329f0a30dda3cd80da4.svg";
export { ForwardRef as ReactComponent };